import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import {
  ColoredStatisticsGroup,
  StatisticsMenuForm,
} from '@pages/statistics-page/interfaces';

@Injectable({
  providedIn: 'root',
})
/** Service used as a trigger for charts date range, resolution and group filtering
 * and stores menu selection values
 */
export class StatisticsMenuValuesService {
  /**
   * @param activeMenuFilterValues$
   * Statistics menu form values. Initially set in statistics-menu component */
  readonly activeMenuFilters$ = new BehaviorSubject<
    StatisticsMenuForm | undefined
  >(undefined);

  get activeMenuFiltersValue(): StatisticsMenuForm | undefined {
    return this.activeMenuFilters$.getValue();
  }

  /**
   * @param pinnedGroups$
   * Pinned groups for statistics filtering. Initially set in
   * group-selection-dialog */
  readonly pinnedGroups$ = new BehaviorSubject<ColoredStatisticsGroup[]>([]);

  get pinnedGroupsValue(): ColoredStatisticsGroup[] {
    return this.pinnedGroups$.getValue();
  }

  public unpinGroup(id: number): void {
    const filteredGroupValue = this.pinnedGroups$.getValue();
    const indexToRemove = filteredGroupValue.findIndex(d => d.id === id);

    filteredGroupValue.splice(indexToRemove, 1);
    this.pinnedGroups$.next(filteredGroupValue);
  }
}
